


























































import { PropType } from 'vue';

import { IInventoryAdvancePayment } from '@/models';

import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';
import snackbar from '@/mixins/snackbar';

import InventoryAdvancePaymentAddAttachmentsFormDialog from './InventoryAdvancePaymentAddAttachmentsFormDialog.vue';
import InventoryAdvancePaymentAttachmentsListItem from './InventoryAdvancePaymentAttachmentsListItem.vue';

const baseMixins = mixins(authMixin, snackbar);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    addAttachmentsFormDialog: InstanceType<
      typeof InventoryAdvancePaymentAddAttachmentsFormDialog
    >;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'InventoryAdvancePaymentAttachmentsList',

    components: {
      InventoryAdvancePaymentAddAttachmentsFormDialog,
      InventoryAdvancePaymentAttachmentsListItem
    },

    props: {
      inventoryAdvancePayment: {
        type: Object as PropType<IInventoryAdvancePayment>,
        required: true
      }
    },

    methods: {
      openCreateAttachmentDialog() {
        this.$refs.addAttachmentsFormDialog.open();
      }
    }
  });
